import script from "./ChartWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartWidget.vue?vue&type=script&setup=true&lang=js"

import "./ChartWidget.vue?vue&type=style&index=0&id=7cb48da6&scoped=true&lang=css"

import exportComponent from "../../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb48da6"]])

export default __exports__